import { render, staticRenderFns } from "./BKButton.vue?vue&type=template&id=4a089fc0&scoped=true"
import script from "./BKButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./BKButton.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BKButton.vue?vue&type=style&index=0&id=4a089fc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a089fc0",
  null
  
)

export default component.exports